import * as React from "react";
import CONSTS from "../../../consts";
export default class Hero extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let supplier = this.props.supplier;
        let heroImageStyle = {
            backgroundImage: `url('${CONSTS.STORAGEURL}/${CONSTS.LICENSEECONTAINER}/${supplier.Id}-Header.jpg')`,
        };
        let inpageNav = this.props.inpageNav;
        return (React.createElement("div", { className: "store-template-a__hero", style: heroImageStyle },
            React.createElement("div", { className: "store-template-a__hero__wrap" },
                React.createElement("div", { className: "caption" },
                    React.createElement("h2", null, supplier.HeroTitle),
                    React.createElement("p", null, supplier.HeroDescription),
                    React.createElement("div", { className: "button-list" },
                        React.createElement("a", { href: "#map", className: "btn-template-a" }, "Find Us"),
                        React.createElement("a", { href: "#contact", className: "btn-template-a btn-clear" }, "Get In Touch")))),
            React.createElement("nav", { className: "inpage" },
                React.createElement("ul", null, inpageNav.map((nav, index) => {
                    return React.createElement("li", { key: index },
                        React.createElement("a", { href: `#${nav}` }, nav));
                })))));
    }
}
;
//# sourceMappingURL=hero.js.map